import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filesize', standalone: false })
export class FileSizePipe implements PipeTransform {
  private readonly measures = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

  public transform(value: number): string {
    return this.convert(value);
  }

  private convert(value: number, measure = 'B'): string {
    if (value < 1000) {
      return `${value.toFixed(1)}${measure}`;
    } else {
      const nextMeasure = this.measures[this.measures.indexOf(measure) + 1];
      if (!nextMeasure) {
        return `${value.toFixed(0)}${measure}`;
      } else {
        return this.convert(value / 1000, nextMeasure);
      }
    }
  }
}
